function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from 'react';
import { pure } from 'recompose';
import SvgIcon from "../../SvgIcon";

var SvgPhone = function SvgPhone(_ref) {
  var _ref$title = _ref.title,
      title = _ref$title === void 0 ? 'Phone' : _ref$title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement(SvgIcon, _extends({
    title: title
  }, props, {
    viewBox: "0 0 48 48"
  }), React.createElement("g", {
    transform: "translate(10.000000, 0.000000)"
  }, React.createElement("path", {
    d: "M16,43 C16,44.105 15.105,45 14,45 C12.895,45 12,44.105 12,43 C12,41.895 12.895,41 14,41 C15.105,41 16,41.895 16,43"
  }), React.createElement("path", {
    d: "M2,38 L26,38 L26,5.015 C26,3.353 24.647,2 22.985,2 L5.015,2 C3.353,2 2,3.353 2,5.015 L2,38 Z M2,40 L2,42.985 C2,44.647 3.353,46 5.015,46 L22.985,46 C24.647,46 26,44.647 26,42.985 L26,40 L2,40 Z M22.985,48 L5.015,48 C2.25,48 0,45.75 0,42.985 L0,5.015 C0,2.25 2.25,0 5.015,0 L22.985,0 C25.75,0 28,2.25 28,5.015 L28,42.985 C28,45.75 25.75,48 22.985,48 L22.985,48 Z"
  })));
};

SvgPhone = pure(SvgPhone);
SvgPhone.displayName = 'SvgPhone';
export default SvgPhone;